module.exports = __webpack_public_path__ + "static/media/vinny.fba24108.jpg";